<script setup lang="ts">
const { t } = useI18n()
const stats = computed(() => [
  { value: t('pitch.stat1Value'), label: t('pitch.stat1Label') },
  { value: t('pitch.stat2Value'), label: t('pitch.stat2Label') },
  { value: t('pitch.stat3Value'), label: t('pitch.stat3Label') },
  { value: t('pitch.stat4Value'), label: t('pitch.stat4Label') },
])
</script>

<template>
  <section class="rod-section relative">
    <div class="rod-container">
      <div class="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-16 items-end mb-14">
        <div data-reveal>
          <div class="rod-eyebrow mb-5">⚡ {{ t('pitch.eyebrow') }}</div>
          <h2 class="rod-h2 leading-tight" v-html="t('pitch.title')" />
        </div>
        <p class="text-lg text-[var(--color-text-muted)] leading-relaxed max-w-xl lg:justify-self-end" data-reveal>
          {{ t('pitch.lead') }}
        </p>
      </div>

      <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        <div v-for="(s, i) in stats" :key="i" class="rod-card text-center py-10" data-reveal>
          <div class="rod-gradient-text font-display font-bold mb-2" style="font-size: clamp(2rem, 4.5vw, 3.2rem); line-height: 1;">
            {{ s.value }}
          </div>
          <div class="text-sm text-[var(--color-text-muted)] uppercase tracking-wider">
            {{ s.label }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
